import Element from "element-ui";

function scheduleRelayout(instance) {
  if (!instance || typeof instance.doLayout !== "function") {
    return;
  }
  clearTimeout(instance.__relayoutTimer);
  instance.__relayoutTimer = setTimeout(() => {
    instance.doLayout();
  }, 80);
}

function patchTableRelayout() {
  const Table = Element.Table;
  if (!Table) {
    return;
  }
  const originalMounted = Table.mounted;
  const originalUpdated = Table.updated;

  Table.mounted = function () {
    originalMounted && originalMounted.apply(this, arguments);
    this.$nextTick(() => scheduleRelayout(this));
  };

  Table.updated = function () {
    originalUpdated && originalUpdated.apply(this, arguments);
    scheduleRelayout(this);
  };
}

export default {
  install() {
    patchTableRelayout();
  },
};
